import Rails from '@rails/ujs';
import '../modules/bootstrap';
import '../modules/date-converter';
import '../modules/navigation';
import '../modules/captcha';
import '../modules/verify-input';
import '../modules/scroll-to-section';

if (!window.Rails) Rails.start();
